import {errorFactroy} from "../error/MadmaxError";
import {ERROR_CODES} from "../error/errorCodes";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import ErrorHandler from "../error/ErrorHandler";
import {inject} from "inversify";

class GameRound {

    private _id: number;
    private _resultIndex: number;
    private _unfinished: boolean;
    private _balanceTmp: number = null;
    private _running: boolean = false;
    private _endRoundEnabled: boolean = false;
    private _skippedIds: number;

    constructor() {

        this._id = 1;
        this._resultIndex = 0;
        this._unfinished = false;
        this._running = false;
        this._endRoundEnabled = false;
        this._skippedIds = 0;
    }

    setEndRoundEnabled(end: boolean) {
        this._endRoundEnabled = end;
    }

    isEndRoundEnabled(): boolean {
        return this._endRoundEnabled;
    }

    setRunning(runnig: boolean) {
        // console.warn("set round running", runnig);
        this._running = runnig;
    }

    isRunning(): boolean {
        return this._running;
    }

    setId(id: number) {
        this._id = id;
    }

    incId() {
        this._id++;
    }

    getId() {
        return this._id;
    }

    incResultIndex() {
        this._resultIndex++;
    }

    resetResultIndex() {
        this._resultIndex = 0;
    }

    getResultIndex(): number {
        return this._resultIndex;
    }

    setUnfinished(bool: boolean = true) {
        this._unfinished = bool;
    }

    isUnfinished(): boolean {
        return this._unfinished;
    }

    setBalanceTmp(val: number) {
        this._balanceTmp = val;
    }

    getBalanceTmp(): number {
        return this._balanceTmp;
    }

    skipId() {
        this.incId();
        this._skippedIds++;
    }

    getSkippedIds() {
        return this._skippedIds;
    }

    resetSkippedIds() {
        this._skippedIds = 0;
    }
}

export default GameRound;